import cn from 'classnames';
import React from 'react';
import intl from '../../locale';
import styles from './WebviewCloseButton.module.css';

export const WebviewCloseButton = ({ className, onClick }: { className?: string; onClick: () => void }) => {
  return (
    <button className={cn(styles.button, className)} onClick={onClick}>
      {intl.formatMessage({ id: 'System.Close' })}
    </button>
  );
};
